import { Slot, Slottable } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { Spinner } from '../spinner/spinner.tsx';
import { buttonSpinner, ButtonVariant, buttonVariants } from './button.css';
import {
  iconButton,
  iconButtonRounded,
  iconButtonSize,
} from './icon-button.css';

type IconButtonProps = {
  inversed?: boolean;
  size?: 'xSmall' | 'small' | 'medium' | 'large';
  variant?: ButtonVariant;
  asChild?: boolean;
  loading?: boolean;
  rounded?: boolean;
  pressed?: boolean;
} & ComponentPropsWithRef<'button'>;

export const IconButton = function ButtonComponent({
  ref,
  size = 'medium',
  variant = 'primary',
  className,
  children,
  inversed,
  asChild = false,
  type = 'button',
  loading = false,
  disabled = false,
  rounded = true,
  pressed,
  ...rest
}: IconButtonProps) {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      ref={ref}
      type={type}
      data-inversed={inversed ? '' : undefined}
      aria-pressed={pressed || rest['aria-pressed']}
      className={clsx(
        iconButton,
        iconButtonSize[size],
        buttonVariants[variant],
        rounded && iconButtonRounded,
        className,
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {!loading ? (
        <Slottable>{children}</Slottable>
      ) : (
        <Spinner className={buttonSpinner} size={size === 'small' ? 16 : 20} />
      )}
    </Component>
  );
};
